// extracted by mini-css-extract-plugin
export default {"buildingCard":"WarBuilding_buildingCard__t4J36","info":"WarBuilding_info__xHPkP"};